import { render } from "./PriceConfirm.vue?vue&type=template&id=3af5cd0f&scoped=true&ts=true"
import script from "./PriceConfirm.vue?vue&type=script&lang=ts"
export * from "./PriceConfirm.vue?vue&type=script&lang=ts"

import "./PriceConfirm.vue?vue&type=style&index=0&id=3af5cd0f&scoped=true&lang=scss"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af5cd0f"]])

export default __exports__